import { styled } from '@mui/material/styles';

export const ResultsDropdown = styled('div')(() => `
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 1300;
  background: white;
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  max-height: 420px;
  overflow-y: auto;
  padding: 6px;
`);

export const ResultItem = styled('button')(() => `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
  text-align: left;
  background: transparent;
  border: none;
  border-radius: 6px;
  padding: 10px 12px;
  cursor: pointer;

  &:not(:last-of-type) {
    border-bottom: 1px solid #EEEEEE;
    border-radius: 6px 6px 0 0;
  }

  &:hover,
  &:focus-visible {
    background: #F5F5F5;
    outline: none;
  }
`);

export const ResultTitle = styled('div')(() => `
  font-size: 14px;
  font-weight: 600;
  color: #212121;
  line-height: 1.3;
`);

export const ResultSnippet = styled('div')(() => `
  font-size: 12px;
  color: #616161;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`);

export const Highlight = styled('mark')(() => `
  background: #FFF3B0;
  color: inherit;
  font-weight: 700;
  padding: 0 1px;
  border-radius: 2px;
`);

export const StatusRow = styled('div')(() => `
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 12px;
  font-size: 13px;
  color: #616161;
`);

export const NoResults = styled('div')(() => `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 20px 12px;
  text-align: center;
`);

export const NoResultsTitle = styled('div')(() => `
  font-size: 14px;
  font-weight: 600;
  color: #212121;
`);

export const NoResultsText = styled('div')(() => `
  font-size: 12px;
  color: #9E9E9E;
`);
